import { Capacitor } from '@capacitor/core';
import { App } from '@capacitor/app';
import { Browser } from '@capacitor/browser';
import { LocalNotifications } from '@capacitor/local-notifications';
import { Network } from '@capacitor/network';
import { Preferences } from '@capacitor/preferences';
import { Share } from '@capacitor/share';
import {
  AdMob,
  BannerAdPluginEvents,
  BannerAdPosition,
  BannerAdSize
} from '@capacitor-community/admob';

const $ = (selector) => document.querySelector(selector);
const SITE_ORIGIN = 'https://lee-apps-pathology-garden.pathology-garden.workers.dev';
const API_URL = Capacitor.isNativePlatform() ? `${SITE_ORIGIN}/api/jobs` : './api/jobs';
const STATE_KEY = 'pathologyGardenStateV2';
const CACHE_STALE_MS = 24 * 60 * 60 * 1000;
const IS_NATIVE = Capacitor.isNativePlatform();
const IS_PRODUCTION_MOBILE = import.meta.env.MODE === 'mobile-production';

const fallbackData = [
  ['강북삼성병원','종로구','seoul-tertiary','rose','https://kbsmcrecruit.ninehire.site/4qxkvknx','서울','tertiary',['university']],
  ['건국대학교병원','광진구','seoul-tertiary','mint','https://www.kuh.ac.kr/intro/recruit/apply/noticeList.do','서울','tertiary',['university']],
  ['경희대학교병원','동대문구','seoul-tertiary','butter','https://recruit.incruit.com/khmc/job/','서울','tertiary',['university']],
  ['고려대학교 구로병원','구로구','seoul-tertiary','sky','https://kumc.recruiter.co.kr/app/jobnotice/list','서울','tertiary',['university']],
  ['삼성서울병원','강남구','seoul-tertiary','peach','https://www.samsunghospital.com/home/recruit/recruitInfo/recruitNotice.do?JOB_CODE=HAC2&ST=ALL','서울','tertiary',['university']],
  ['서울대학교병원','종로구','seoul-tertiary','lavender','https://recruit.snuh.org/joining/recruit/list.do','서울','tertiary',['university']],
  ['강남세브란스병원','강남구','seoul-tertiary','mint','https://yuhs.recruiter.co.kr/app/jobnotice/list','서울','tertiary',['university']],
  ['세브란스병원','서대문구','seoul-tertiary','sky','https://yuhs.recruiter.co.kr/app/jobnotice/list','서울','tertiary',['university']],
  ['이화여자대학교 목동병원','양천구','seoul-tertiary','rose','https://mokdong.eumc.ac.kr/intro/recrut/list.do','서울','tertiary',['university']],
  ['서울아산병원','송파구','seoul-tertiary','mint','https://recruit.amc.seoul.kr/recruit/career/list.do?codeFirst=T04005','서울','tertiary',['university']],
  ['중앙대학교병원','동작구','seoul-tertiary','butter','https://caumc.recruiter.co.kr/app/jobnotice/list','서울','tertiary',['university']],
  ['고려대학교 안암병원','성북구','seoul-tertiary','lavender','https://kumc.recruiter.co.kr/app/jobnotice/list','서울','tertiary',['university']],
  ['가톨릭대학교 서울성모병원','서초구','seoul-tertiary','rose','https://recruit.cmcnu.or.kr/cmcseoul/index.do','서울','tertiary',['university','catholic']],
  ['한양대학교병원','성동구','seoul-tertiary','sky','https://hyumc.recruiter.co.kr/app/jobnotice/list','서울','tertiary',['university']],
  ['강동경희대학교병원','강동구','seoul-university','lavender','https://recruit.incruit.com/khmc/job/','서울','general',['university']],
  ['차의과학대학교 강남차병원','강남구','seoul-university','peach','https://recruit.chamc.co.kr/','서울','general',['university']],
  ['노원을지대학교병원','노원구','seoul-university','mint','https://eulji.or.kr/info/info_pg06_04.jsp?board_code=BOARD_4','서울','general',['university']],
  ['순천향대학교 서울병원','용산구','seoul-university','sky','https://www.schmc.ac.kr/seoul/index.do','서울','general',['university']],
  ['이화여자대학교 서울병원','강서구','seoul-university','rose','https://seoul.eumc.ac.kr/intro/recrut/list.do','서울','general',['university']],
  ['인제대학교 상계백병원','노원구','seoul-university','butter','https://paik.recruiter.co.kr/app/jobnotice/list','서울','general',['university']],
  ['한림대학교 강남성심병원','영등포구','seoul-university','lavender','https://recruit.hallym.or.kr/','서울','general',['university']],
  ['한림대학교 한강성심병원','영등포구','seoul-university','peach','https://recruit.hallym.or.kr/','서울','general',['university']],
  ['가톨릭대학교 여의도성모병원','영등포구','seoul-university','peach','https://recruit.cmcnu.or.kr/cmcsungmo/index.do','서울','general',['university','catholic']],
  ['가톨릭대학교 은평성모병원','은평구','seoul-university','lavender','https://recruit.cmcnu.or.kr/cmcep/index.do','서울','general',['university','catholic']],
  ['서울특별시 보라매병원','동작구','seoul-university','mint','https://brmh.recruiter.co.kr/app/jobnotice/list','서울','general',['university','partner']],
  ['삼육서울병원','동대문구','seoul-university','sky','https://symcs.recruiter.co.kr/app/jobnotice/list','서울','general',['university','partner']],
  ['가톨릭대학교 성빈센트병원','경기 수원시','gyeonggi-tertiary','butter','https://recruit.cmcnu.or.kr/cmcvincent/index.do','경기','tertiary',['university','catholic']],
  ['고려대학교 안산병원','경기 안산시','gyeonggi-tertiary','sky','https://kumc.recruiter.co.kr/app/jobnotice/list','경기','tertiary',['university']],
  ['분당서울대학교병원','경기 성남시','gyeonggi-tertiary','lavender','https://snubh.recruiter.co.kr/app/jobnotice/list','경기','tertiary',['university']],
  ['순천향대학교 부천병원','경기 부천시','gyeonggi-tertiary','mint','https://www.schmc.ac.kr/bucheon/index.do','경기','tertiary',['university']],
  ['아주대학교병원','경기 수원시','gyeonggi-tertiary','rose','https://ajoumc.recruiter.co.kr/app/jobnotice/list','경기','tertiary',['university']],
  ['한림대학교성심병원','경기 안양시','gyeonggi-tertiary','peach','https://recruit.hallym.or.kr/','경기','tertiary',['university']],
  ['동국대학교 일산병원','경기 고양시','gyeonggi-university','butter','http://www.dumc.or.kr/hospital/recruit/hospitalRecruitList.jsp?nowMenuId=00000130&nowPageInfo=ILSH','경기','general',['university']],
  ['연세대학교 용인세브란스병원','경기 용인시','gyeonggi-university','mint','https://yuhs.recruiter.co.kr/app/jobnotice/list','경기','general',['university']],
  ['인제대학교 일산백병원','경기 고양시','gyeonggi-university','rose','https://paik.recruiter.co.kr/app/jobnotice/list','경기','general',['university']],
  ['중앙대학교광명병원','경기 광명시','gyeonggi-university','sky','https://caumc.recruiter.co.kr/app/jobnotice/list','경기','general',['university']],
  ['차의과학대학교 분당차병원','경기 성남시','gyeonggi-university','peach','https://recruit.chamc.co.kr/','경기','general',['university']],
  ['차의과학대학교 일산차병원','경기 고양시','gyeonggi-university','lavender','https://recruit.chamc.co.kr/','경기','general',['university']],
  ['의정부을지대학교병원','경기 의정부시','gyeonggi-university','mint','https://www.emc.ac.kr/info/info_pg06_04.jsp?board_code=BOARD_4','경기','general',['university']],
  ['한림대학교 동탄성심병원','경기 화성시','gyeonggi-university','butter','https://recruit.hallym.or.kr/','경기','general',['university']],
  ['한양대학교 구리병원','경기 구리시','gyeonggi-university','sky','https://hyumc.recruiter.co.kr/app/jobnotice/list','경기','general',['university']],
  ['가톨릭대학교 의정부성모병원','경기 의정부시','gyeonggi-university','mint','https://recruit.cmcnu.or.kr/cmcujb/index.do','경기','general',['university','catholic']],
  ['가톨릭대학교 부천성모병원','경기 부천시','gyeonggi-university','rose','https://recruit.cmcnu.or.kr/cmcbucheon/index.do','경기','general',['university','catholic']],
  ['명지병원','경기 고양시','gyeonggi-university','peach','https://mjh.or.kr/employ/recruit_notice/list.do','경기','general',['university','partner']],
  ['가톨릭대학교 인천성모병원','인천 부평구','other-catholic','sky','https://cmcism.recruiter.co.kr/app/jobnotice/list','인천','general',['university','catholic']],
  ['가톨릭대학교 대전성모병원','대전 중구','other-catholic','peach','https://recruit.cmcnu.or.kr/cmcdj/index.do','대전','general',['university','catholic']]
];
const fallbackHospitals = fallbackData.map(([name, district, category, tone, url, region, grade, extraTags], index) => ({ id: `hospital-${index + 1}`, name, district, category, tone, url, region, grade, tags: [...new Set([region, grade, ...extraTags])] }));

let hospitals = fallbackHospitals;
let customJobs = [];
let saved = [];
let liveJobs = [];
let sourceStatus = [];
let cachedPayload = null;
let cacheSavedAt = null;
let notificationsEnabled = false;
let scheduledNotificationIds = [];
let loadingJobs = false;
let onlySaved = false;
let activeCategory = 'all';
let activeJobTag = 'all';

function allJobs() { return [...customJobs, ...liveJobs]; }
function stateSnapshot() { return { version: 2, customJobs, saved, cachedPayload, cacheSavedAt, notificationsEnabled, scheduledNotificationIds }; }
async function persist() {
  const value = JSON.stringify(stateSnapshot());
  await Preferences.set({ key: STATE_KEY, value });
  if (!IS_NATIVE) {
    localStorage.setItem('pathologyGardenJobs', JSON.stringify(customJobs));
    localStorage.setItem('pathologyGardenSaved', JSON.stringify(saved));
  }
}
function safeJson(value, fallback) {
  try { return value ? JSON.parse(value) : fallback; } catch { return fallback; }
}
async function restoreState() {
  const stored = await Preferences.get({ key: STATE_KEY });
  const v2 = safeJson(stored.value, null);
  if (v2?.version === 2) {
    customJobs = Array.isArray(v2.customJobs) ? v2.customJobs : [];
    saved = Array.isArray(v2.saved) ? v2.saved : [];
    cachedPayload = v2.cachedPayload || null;
    cacheSavedAt = v2.cacheSavedAt || null;
    notificationsEnabled = Boolean(v2.notificationsEnabled);
    scheduledNotificationIds = Array.isArray(v2.scheduledNotificationIds) ? v2.scheduledNotificationIds : [];
    return;
  }
  customJobs = safeJson(localStorage.getItem('pathologyGardenJobs'), []);
  saved = safeJson(localStorage.getItem('pathologyGardenSaved'), []);
  await persist();
}
function escapeHtml(value = '') { return String(value).replace(/[&<>'"]/g, char => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#039;', '"': '&quot;' })[char]); }
function shortDate(value) { return value ? value.replace(/-/g, '.') : '날짜 확인'; }
function period(job) { return job.postedAt && job.deadline ? `${shortDate(job.postedAt)} ~ ${shortDate(job.deadline)}` : job.deadline ? `~ ${shortDate(job.deadline)}` : job.postedAt ? `${shortDate(job.postedAt)} 게시 · 마감일 상세 확인` : '공고에서 접수기간 확인'; }
const categoryMeta = {
  'seoul-tertiary': { label: '서울 상급종합병원', note: '제5기(2024–2026) 지정 기준' },
  'seoul-university': { label: '서울 대학·연계병원', note: '대학 부속·운영·교육 연계 병원' },
  'gyeonggi-tertiary': { label: '경기 상급종합병원', note: '제5기(2024–2026) 지정 기준' },
  'gyeonggi-university': { label: '경기 대학·연계병원', note: '대학 부속·운영·교육 연계 병원' },
  'other-catholic': { label: '기타 가톨릭 연계병원', note: '인천·대전 가톨릭대학교 연계 병원' },
  custom: { label: '직접 담은 공고', note: '내가 저장한 병원' }
};
const categoryOrder = Object.keys(categoryMeta).filter(category => category !== 'custom');
function categoryName(category) { return categoryMeta[category]?.label || '대학·연계병원'; }
function hospitalForJob(job) { return hospitals.find(hospital => hospital.name === job.hospital); }
function matchesTag(hospital, tag) {
  if (tag === 'all') return true;
  if (!hospital) return false;
  return hospital.region === tag || hospital.grade === tag || (hospital.tags || []).includes(tag);
}

function populateDistrictFilter() {
  const select = $('#districtFilter');
  const current = select.value;
  const districts = [...new Set(hospitals.map(hospital => hospital.district))].sort((a, b) => a.localeCompare(b, 'ko'));
  select.innerHTML = '<option value="all">지역 전체</option>' + districts.map(district => `<option value="${escapeHtml(district)}">${escapeHtml(district)}</option>`).join('');
  select.value = districts.includes(current) ? current : 'all';
}

function jobsMatchingControls() {
  const keyword = $('#searchInput').value.trim().toLowerCase();
  const district = $('#districtFilter').value;
  const status = $('#typeFilter').value;
  return allJobs().filter(job => {
    const haystack = `${job.hospital} ${job.title} ${job.department || ''} ${job.memo || ''}`.toLowerCase();
    const hospital = hospitalForJob(job);
    const tagMatch = activeJobTag === 'all' || matchesTag(hospital, activeJobTag);
    return (!keyword || haystack.includes(keyword)) && (district === 'all' || job.district === district) && (status === 'all' || job.status === status) && tagMatch && (!onlySaved || saved.includes(job.id));
  });
}

function visibleHospitals(jobs) {
  const keyword = $('#searchInput').value.trim().toLowerCase();
  const district = $('#districtFilter').value;
  const status = $('#typeFilter').value;
  return hospitals.filter(hospital => {
    const categoryMatch = activeCategory === 'all' || hospital.category === activeCategory;
    const tagMatch = matchesTag(hospital, activeJobTag);
    const districtMatch = district === 'all' || hospital.district === district;
    const relatedJobs = jobs.filter(job => job.hospital === hospital.name);
    const hospitalKeywordMatch = !keyword || `${hospital.name} ${hospital.district}`.toLowerCase().includes(keyword);
    const jobKeywordMatch = relatedJobs.length > 0;
    const keywordMatch = hospitalKeywordMatch || jobKeywordMatch;
    const needsMatchingJob = status !== 'all' || onlySaved || (keyword && !hospitalKeywordMatch);
    const resultMatch = !needsMatchingJob || relatedJobs.length > 0;
    return categoryMatch && tagMatch && districtMatch && keywordMatch && resultMatch;
  });
}

function renderCategoryTabs() {
  const buttons = [{ id: 'all', label: '전체' }, ...categoryOrder.map(id => ({ id, label: categoryMeta[id].label }))];
  $('#categoryTabs').innerHTML = buttons.map(({ id, label }) => {
    const count = id === 'all' ? hospitals.length : hospitals.filter(hospital => hospital.category === id).length;
    return `<button class="${activeCategory === id ? 'active' : ''}" type="button" data-category="${id}">${escapeHtml(label)} <b>${count}</b></button>`;
  }).join('');
  $('#hospitalCount').textContent = hospitals.length;
}

function renderDirectory() {
  const categories = categoryOrder.filter(category => activeCategory === 'all' || activeCategory === category);
  $('#hospitalDirectoryList').innerHTML = categories.map(category => {
    const categoryHospitals = hospitals.filter(hospital => hospital.category === category);
    const items = categoryHospitals.map(hospital => `<button type="button" class="directory-item tone-${escapeHtml(hospital.tone)}" data-hospital="${escapeHtml(hospital.name)}"><span class="directory-flower">✿</span><span><strong>${escapeHtml(hospital.name)}</strong><small>${escapeHtml(hospital.district)}</small></span><i>→</i></button>`).join('');
    return `<section class="directory-group"><header><div><h3>${categoryName(category)}</h3><p>${escapeHtml(categoryMeta[category].note)}</p></div><strong>${categoryHospitals.length}<small>곳</small></strong></header><div class="directory-items">${items}</div></section>`;
  }).join('');
}

function renderJobRow(job) {
  const isSaved = saved.includes(job.id);
  const memo = job.memo ? `<p class="row-memo">📝 ${escapeHtml(job.memo)}</p>` : '';
  const deleteButton = job.custom ? `<button class="row-tool row-delete" type="button" aria-label="${escapeHtml(job.title)} 삭제" data-delete="${escapeHtml(job.id)}">삭제</button>` : '';
  return `<article class="actual-job-row"><div class="actual-job-main"><div class="row-labels"><span>${escapeHtml(job.career || job.type || '채용')}</span><span>${escapeHtml(job.department || '임상병리사')}</span></div><h4>${escapeHtml(job.title)}</h4><p class="job-period"><time>${escapeHtml(period(job))}</time></p>${memo}</div><div class="actual-job-actions"><span class="status-pill ${job.status === '접수중' ? 'status-open' : ''}">${escapeHtml(job.status || '확인')}</span><div class="row-tools"><button class="row-save ${isSaved ? 'is-saved' : ''}" type="button" aria-label="${escapeHtml(job.title)} 찜하기" data-save="${escapeHtml(job.id)}">${isSaved ? '♥' : '♡'}</button><button class="row-tool" type="button" aria-label="${escapeHtml(job.title)} 공유" data-share="${escapeHtml(job.id)}">공유</button>${deleteButton}</div><a href="${escapeHtml(job.url)}" target="_blank" rel="noopener noreferrer">상세 공고 <b>↗</b></a></div></article>`;
}

function renderHospitalGroup(hospital, jobs) {
  const active = jobs.filter(job => job.status !== '마감');
  const closed = jobs.filter(job => job.status === '마감');
  const status = $('#typeFilter').value;
  const source = sourceStatus.find(item => item.name === hospital.name);
  const directJobs = status === '마감' ? closed : active;
  const directRows = directJobs.map(renderJobRow).join('');
  const headingLabel = status === '마감' ? '마감' : '접수중';
  const quietEmpty = directJobs.length || status === '마감' ? '' : source?.ok === false
    ? '<div class="no-current-job source-warning"><span>☂</span><p><strong>오늘은 공식 채용관을 확인하지 못했어요.</strong><small>사이트 구조 변경이나 일시 오류일 수 있어요. 공식 채용관에서 직접 확인해 주세요.</small></p></div>'
    : '<div class="no-current-job"><span>☁</span><p><strong>현재 접수 중인 임상병리사 공고가 없어요.</strong><small>마지막 확인 이후 새 공고는 하루 간격으로 다시 확인해요.</small></p></div>';
  const closedRows = status === 'all' && closed.length ? `<details class="closed-jobs"><summary>최근 마감 공고 ${closed.length}건 보기 <span>⌄</span></summary><div class="actual-job-rows">${closed.map(renderJobRow).join('')}</div></details>` : '';
  return `<section class="hospital-group ${directJobs.length ? 'has-open-jobs' : 'quiet-group'} tone-${escapeHtml(hospital.tone || 'lavender')}"><header class="hospital-group-heading"><div><span class="hospital-symbol">✿</span><div><h3>${escapeHtml(hospital.name)}</h3><p>${escapeHtml(hospital.district)} · ${categoryName(hospital.category)}</p></div></div><div class="hospital-heading-actions"><strong>${directJobs.length}<small>${headingLabel}</small></strong><a href="${escapeHtml(hospital.url)}" target="_blank" rel="noopener noreferrer">공식 채용관 ↗</a></div></header>${directRows ? `<div class="actual-job-rows">${directRows}</div>` : ''}${quietEmpty}${closedRows}</section>`;
}

function renderJobs() {
  const shown = jobsMatchingControls();
  const catalog = visibleHospitals(shown);
  const groups = catalog.map(hospital => renderHospitalGroup(hospital, shown.filter(job => job.hospital === hospital.name)));
  const catalogNames = new Set(hospitals.map(hospital => hospital.name));
  const extraJobs = shown.filter(job => !catalogNames.has(job.hospital));
  if (extraJobs.length) {
    const extras = [...new Set(extraJobs.map(job => job.hospital))].map(name => ({ name, district: extraJobs.find(job => job.hospital === name)?.district || '서울', category: 'custom', tone: 'rose', url: extraJobs.find(job => job.hospital === name)?.url || '#' }));
    groups.push(...extras.map(hospital => renderHospitalGroup(hospital, extraJobs.filter(job => job.hospital === hospital.name))));
  }
  $('#jobCount').textContent = shown.length;
  $('#savedCount').textContent = saved.length;
  $('#jobGrid').innerHTML = groups.join('');
  $('#emptyState').classList.toggle('hidden', groups.length !== 0);
  $('#jobGrid').classList.toggle('hidden', groups.length === 0);
}

function setCategory(category) {
  activeCategory = category;
  renderCategoryTabs();
  renderDirectory();
  renderJobs();
}

function setSavedMode(value) {
  onlySaved = value;
  $('#savedFilter').classList.toggle('active', value);
  $('#savedOnlyBtn').classList.toggle('active', value);
  document.querySelectorAll('[data-job-tag]').forEach(button => button.classList.toggle('active', !value && button.dataset.jobTag === activeJobTag));
  renderJobs();
}

function setJobTag(tag) {
  activeJobTag = tag;
  onlySaved = false;
  $('#savedFilter').classList.remove('active');
  $('#savedOnlyBtn').classList.remove('active');
  document.querySelectorAll('[data-job-tag]').forEach(button => button.classList.toggle('active', button.dataset.jobTag === tag));
  renderJobs();
}

$('#categoryTabs').addEventListener('click', event => { const category = event.target.closest('[data-category]')?.dataset.category; if (category) setCategory(category); });
$('#hospitalDirectoryList').addEventListener('click', event => {
  const hospital = event.target.closest('[data-hospital]')?.dataset.hospital;
  if (!hospital) return;
  $('#searchInput').value = hospital;
  $('#districtFilter').value = 'all';
  setCategory('all');
  $('#jobs').scrollIntoView({ behavior: 'smooth', block: 'start' });
});
$('#searchInput').addEventListener('input', renderJobs);
$('#districtFilter').addEventListener('change', renderJobs);
$('#typeFilter').addEventListener('change', renderJobs);
$('#jobTagFilters').addEventListener('click', event => {
  const tag = event.target.closest('[data-job-tag]')?.dataset.jobTag;
  if (tag) setJobTag(tag);
});
$('#savedFilter').addEventListener('click', () => setSavedMode(true));
$('#savedOnlyBtn').addEventListener('click', () => { setSavedMode(!onlySaved); $('#jobs').scrollIntoView({ behavior: 'smooth' }); });
$('#resetFilters').addEventListener('click', () => { $('#searchInput').value = ''; $('#districtFilter').value = 'all'; $('#typeFilter').value = 'all'; setCategory('all'); setJobTag('all'); });

$('#jobGrid').addEventListener('click', async event => {
  const saveId = event.target.closest('[data-save]')?.dataset.save;
  if (saveId) {
    saved = saved.includes(saveId) ? saved.filter(savedId => savedId !== saveId) : [...saved, saveId];
    await persist();
    if (IS_NATIVE && notificationsEnabled) await rescheduleDeadlineNotifications();
    renderJobs();
    return;
  }
  const shareId = event.target.closest('[data-share]')?.dataset.share;
  if (shareId) {
    const job = allJobs().find(item => item.id === shareId);
    if (job) await shareJob(job);
    return;
  }
  const deleteId = event.target.closest('[data-delete]')?.dataset.delete;
  if (!deleteId) return;
  const job = customJobs.find(item => item.id === deleteId);
  if (!job || !window.confirm(`‘${job.title}’ 공고를 삭제할까요?`)) return;
  customJobs = customJobs.filter(item => item.id !== deleteId);
  saved = saved.filter(id => id !== deleteId);
  await persist();
  if (IS_NATIVE && notificationsEnabled) await rescheduleDeadlineNotifications();
  renderJobs();
});

async function shareJob(job) {
  const promotion = `병리의 숲에서 서울·경기 임상병리사 채용공고를 함께 살펴보세요.\n${SITE_ORIGIN}`;
  const shareText = `${job.hospital} · ${job.title}\n\n${promotion}`;
  const clipboardText = `${shareText}\n\n공식 상세 공고\n${job.url}`;
  try {
    if (IS_NATIVE) await Share.share({ title: `${job.hospital} 채용공고`, text: shareText, url: job.url, dialogTitle: '채용공고 공유' });
    else if (navigator.share) await navigator.share({ title: `${job.hospital} 채용공고`, text: shareText, url: job.url });
    else {
      await navigator.clipboard.writeText(clipboardText);
      setLiveStatus('공고와 병리의 숲 안내를 클립보드에 복사했어요.', '🌿');
    }
  } catch (error) {
    if (error?.name !== 'AbortError') setLiveStatus('공유 창을 열지 못했어요. 공식 공고 링크를 이용해 주세요.', '☂');
  }
}

const modal = $('#addModal');
function openAddModal() {
  if (typeof modal.showModal === 'function') modal.showModal();
  else modal.setAttribute('open', '');
  document.body.classList.add('modal-open');
  requestAnimationFrame(() => $('#closeAddModal').focus({ preventScroll: true }));
}
function closeAddModal() {
  if (typeof modal.close === 'function' && modal.open) modal.close();
  else modal.removeAttribute('open');
  document.body.classList.remove('modal-open');
}
$('#openAddModal').addEventListener('click', openAddModal);
$('#closeAddModal').addEventListener('click', closeAddModal);
modal.addEventListener('close', () => document.body.classList.remove('modal-open'));
modal.addEventListener('cancel', event => { event.preventDefault(); closeAddModal(); });
modal.addEventListener('click', event => {
  if (event.target !== modal) return;
  const rect = modal.getBoundingClientRect();
  const inside = event.clientX >= rect.left && event.clientX <= rect.right && event.clientY >= rect.top && event.clientY <= rect.bottom;
  if (!inside) closeAddModal();
});
$('#addJobForm').addEventListener('submit', async event => {
  event.preventDefault();
  const data = new FormData(event.currentTarget);
  const job = { id: `mine-${Date.now()}`, hospital: data.get('hospital').trim(), district: data.get('district'), title: data.get('title').trim(), type: data.get('type'), career: data.get('type'), status: '내 공고', postedAt: '', deadline: data.get('deadline'), url: data.get('url').trim(), memo: data.get('memo').trim(), department: '내가 직접 담은 공고', tone: 'rose', custom: true };
  customJobs = [job, ...customJobs];
  saved = [job.id, ...saved];
  await persist();
  if (IS_NATIVE && notificationsEnabled) await rescheduleDeadlineNotifications();
  event.currentTarget.reset(); closeAddModal(); setCategory('all'); setJobTag('all'); renderJobs(); $('#jobs').scrollIntoView({ behavior: 'smooth', block: 'start' });
});

const settingsModal = $('#settingsModal');
function openSettings() {
  updateNotificationButton();
  if (typeof settingsModal.showModal === 'function') settingsModal.showModal();
  else settingsModal.setAttribute('open', '');
  document.body.classList.add('modal-open');
}
function closeSettings() {
  if (typeof settingsModal.close === 'function' && settingsModal.open) settingsModal.close();
  else settingsModal.removeAttribute('open');
  document.body.classList.remove('modal-open');
}
function updateNotificationButton() {
  const button = $('#notificationToggle');
  button.textContent = notificationsEnabled ? '알림 켜짐' : '알림 켜기';
  button.classList.toggle('is-active', notificationsEnabled);
  button.disabled = !IS_NATIVE;
  if (!IS_NATIVE) button.textContent = '앱에서 사용';
}
$('#openSettings').addEventListener('click', openSettings);
$('#closeSettings').addEventListener('click', closeSettings);
settingsModal.addEventListener('close', () => document.body.classList.remove('modal-open'));
settingsModal.addEventListener('cancel', event => { event.preventDefault(); closeSettings(); });
settingsModal.addEventListener('click', event => {
  if (event.target !== settingsModal) return;
  const rect = settingsModal.getBoundingClientRect();
  if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) closeSettings();
});

function notificationId(jobId, daysBefore) {
  let hash = 2166136261;
  for (const char of `${jobId}:${daysBefore}`) hash = Math.imul(hash ^ char.charCodeAt(0), 16777619);
  return Math.abs(hash % 2000000000) + 1;
}
function notificationDate(deadline, daysBefore) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(deadline || '')) return null;
  const date = new Date(`${deadline}T09:00:00`);
  if (Number.isNaN(date.getTime())) return null;
  date.setDate(date.getDate() - daysBefore);
  return date > new Date() ? date : null;
}
async function cancelGardenNotifications() {
  if (!IS_NATIVE) return;
  const pending = await LocalNotifications.getPending();
  const knownIds = new Set(scheduledNotificationIds);
  for (const item of pending.notifications || []) {
    if (item.extra?.namespace === STATE_KEY) knownIds.add(item.id);
  }
  const mine = [...knownIds].map(id => ({ id }));
  if (mine.length) await LocalNotifications.cancel({ notifications: mine });
  scheduledNotificationIds = [];
}
async function rescheduleDeadlineNotifications() {
  if (!IS_NATIVE) return;
  await cancelGardenNotifications();
  if (!notificationsEnabled) {
    await persist();
    return;
  }
  const notifications = [];
  for (const job of allJobs().filter(item => saved.includes(item.id) && item.status !== '마감' && item.deadline)) {
    for (const daysBefore of [3, 1]) {
      const at = notificationDate(job.deadline, daysBefore);
      if (!at) continue;
      notifications.push({
        id: notificationId(job.id, daysBefore),
        title: `${job.hospital} 공고 마감 D-${daysBefore}`,
        body: `${job.title} · ${job.deadline} 마감`,
        schedule: { at, allowWhileIdle: true },
        extra: { namespace: STATE_KEY, jobId: job.id, url: job.url, daysBefore }
      });
    }
  }
  if (notifications.length) await LocalNotifications.schedule({ notifications });
  scheduledNotificationIds = notifications.map(item => item.id);
  await persist();
}
$('#notificationToggle').addEventListener('click', async () => {
  if (!IS_NATIVE) return;
  if (!notificationsEnabled) {
    const permission = await LocalNotifications.requestPermissions();
    if (permission.display !== 'granted') {
      setLiveStatus('알림 권한이 허용되지 않았어요. 기기 설정에서 변경할 수 있어요.', '☂');
      return;
    }
    notificationsEnabled = true;
    await persist();
    if (Capacitor.getPlatform() === 'android') {
      const exact = await LocalNotifications.checkExactNotificationSetting();
      if (exact.exact_alarm !== 'granted') {
        setLiveStatus('오전 9시 알림을 정확히 받으려면 이어서 표시되는 기기 설정에서 정확한 알람을 허용해 주세요.', '🌿');
        await LocalNotifications.changeExactNotificationSetting();
      }
    }
  } else {
    notificationsEnabled = false;
  }
  await persist();
  await rescheduleDeadlineNotifications();
  updateNotificationButton();
});

$('#clearLocalData').addEventListener('click', async () => {
  if (!window.confirm('이 기기에 저장된 찜, 직접 공고, 캐시와 알림을 모두 삭제할까요?')) return;
  await cancelGardenNotifications();
  await Preferences.remove({ key: STATE_KEY });
  localStorage.removeItem('pathologyGardenJobs');
  localStorage.removeItem('pathologyGardenSaved');
  customJobs = []; saved = []; cachedPayload = null; cacheSavedAt = null; notificationsEnabled = false; scheduledNotificationIds = [];
  liveJobs = []; sourceStatus = []; hospitals = fallbackHospitals;
  populateDistrictFilter(); renderCategoryTabs(); renderDirectory(); renderJobs(); updateNotificationButton();
  setLiveStatus('이 기기에 저장된 데이터를 모두 삭제했어요.', '🌿');
});

function setLiveStatus(message, icon = '🌼') {
  const text = $('#liveStatus p');
  if (text) text.innerHTML = `<span>${icon}</span> ${escapeHtml(message)}`;
}
function applyPayload(payload) {
  hospitals = payload?.hospitals?.length ? payload.hospitals : fallbackHospitals;
  liveJobs = Array.isArray(payload?.jobs) ? payload.jobs : [];
  sourceStatus = Array.isArray(payload?.sourceStatus) ? payload.sourceStatus : [];
}
function renderAll() {
  populateDistrictFilter();
  renderCategoryTabs();
  renderDirectory();
  renderJobs();
}
function cacheStatusMessage() {
  const savedAt = cacheSavedAt ? new Date(cacheSavedAt) : null;
  const age = savedAt ? Date.now() - savedAt.getTime() : Infinity;
  const label = savedAt && !Number.isNaN(savedAt.getTime()) ? savedAt.toLocaleString('ko-KR', { month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit' }) : '이전';
  return age > CACHE_STALE_MS ? `${label}에 저장한 공고를 보여드려요. 오래된 정보일 수 있으니 공식 공고를 확인해 주세요.` : `${label}에 저장한 공고를 오프라인으로 보여드려요.`;
}

async function loadLiveJobs({ manual = false } = {}) {
  if (loadingJobs) return;
  loadingJobs = true;
  $('#retryJobs').disabled = true;
  if (manual) setLiveStatus('공식 채용 게시판을 다시 확인하고 있어요.');
  try {
    const response = await fetch(API_URL, { cache: 'no-store', headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('공식 게시판을 불러오지 못했습니다.');
    const payload = await response.json();
    applyPayload(payload);
    cachedPayload = payload;
    cacheSavedAt = new Date().toISOString();
    await persist();
    const checked = payload.refreshedAt ? new Date(payload.refreshedAt).toLocaleString('ko-KR', { month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' }) : '방금';
    const checkedCount = new Set(sourceStatus.filter(item => item.ok).map(item => item.name)).size;
    const failedCount = sourceStatus.filter(item => item.ok === false).length;
    const suffix = failedCount ? ` · ${failedCount}곳은 일시적으로 확인하지 못했어요.` : '';
    setLiveStatus(`${checked} 확인 · 공식 채용관 ${checkedCount}/${hospitals.length}곳 확인 완료${suffix}`);
    if (IS_NATIVE && notificationsEnabled) await rescheduleDeadlineNotifications();
  } catch {
    if (cachedPayload) {
      applyPayload(cachedPayload);
      setLiveStatus(cacheStatusMessage(), '☂');
    } else {
      setLiveStatus('공식 공고를 불러오지 못했어요. 내장된 병원 목록과 공식 채용관 링크는 이용할 수 있어요.', '☂');
    }
  } finally {
    renderAll();
    loadingJobs = false;
    $('#retryJobs').disabled = false;
  }
}

$('#retryJobs').addEventListener('click', () => loadLiveJobs({ manual: true }));

async function initializeNativeShell() {
  if (!IS_NATIVE) return;
  App.addListener('backButton', () => {
    if (settingsModal.open || settingsModal.hasAttribute('open')) {
      closeSettings();
      return;
    }
    if (modal.open || modal.hasAttribute('open')) {
      closeAddModal();
      return;
    }
    App.exitApp();
  });
  const status = await Network.getStatus();
  if (!status.connected && cachedPayload) setLiveStatus(cacheStatusMessage(), '☂');
  Network.addListener('networkStatusChange', next => {
    if (!next.connected) setLiveStatus(cachedPayload ? cacheStatusMessage() : '현재 오프라인이에요. 병원 목록과 저장한 공고를 이용할 수 있어요.', '☂');
    else loadLiveJobs({ manual: true });
  });
  App.addListener('resume', async () => {
    if (notificationsEnabled) await rescheduleDeadlineNotifications();
    await loadLiveJobs();
  });
  LocalNotifications.addListener('localNotificationActionPerformed', async action => {
    const url = action.notification.extra?.url;
    if (url) await Browser.open({ url });
  });
  document.addEventListener('click', async event => {
    const anchor = event.target.closest('a[href]');
    const href = anchor?.getAttribute('href')?.trim();
    if (!href || !/^https?:\/\//i.test(href)) return;
    event.preventDefault();
    await Browser.open({ url: href });
  });
}

async function initializeAds() {
  if (!IS_NATIVE) return;
  const platform = Capacitor.getPlatform();
  const testId = platform === 'ios' ? 'ca-app-pub-3940256099942544/2934735716' : 'ca-app-pub-3940256099942544/9214589741';
  const productionId = platform === 'ios' ? import.meta.env.VITE_ADMOB_IOS_BANNER_ID : import.meta.env.VITE_ADMOB_ANDROID_BANNER_ID;
  const useProduction = IS_PRODUCTION_MOBILE && Boolean(productionId);
  await AdMob.initialize({ initializeForTesting: !useProduction });
  let consent = await AdMob.requestConsentInfo({ tagForUnderAgeOfConsent: false });
  if (consent.isConsentFormAvailable && !consent.canRequestAds) consent = await AdMob.showConsentForm();
  const privacyRequired = consent.privacyOptionsRequirementStatus === 'REQUIRED';
  $('#privacyOptions').hidden = !privacyRequired;
  if (!consent.canRequestAds) return;
  AdMob.addListener(BannerAdPluginEvents.SizeChanged, size => {
    const height = Number(size.height || 0);
    if (height > 0) document.documentElement.style.setProperty('--ad-banner-height', `${height}px`);
  });
  await AdMob.showBanner({
    adId: useProduction ? productionId : testId,
    adSize: BannerAdSize.ADAPTIVE_BANNER,
    position: BannerAdPosition.BOTTOM_CENTER,
    margin: 0,
    isTesting: !useProduction,
    npa: true
  });
  document.body.classList.add('native-ad-active');
}

$('#privacyOptions').addEventListener('click', async () => {
  if (!IS_NATIVE) return;
  try { await AdMob.showPrivacyOptionsForm(); } catch { setLiveStatus('광고 개인정보 선택 화면을 열지 못했어요. 잠시 후 다시 시도해 주세요.', '☂'); }
});

async function bootstrap() {
  await restoreState();
  if (cachedPayload) applyPayload(cachedPayload);
  renderAll();
  updateNotificationButton();
  if (cachedPayload) setLiveStatus(cacheStatusMessage());
  await initializeNativeShell();
  await loadLiveJobs();
  await initializeAds().catch(() => setLiveStatus('광고 영역을 준비하지 못했지만 공고는 정상적으로 이용할 수 있어요.', '☂'));
  const { SplashScreen } = await import('@capacitor/splash-screen');
  await SplashScreen.hide().catch(() => {});
}

bootstrap().catch(() => {
  renderAll();
  setLiveStatus('앱을 준비하는 중 문제가 생겼어요. 새로 확인을 눌러 다시 시도해 주세요.', '☂');
});
